const translate = (  toTranslate,  language , translationDb ) => {
    if( translationDb[toTranslate] && translationDb[toTranslate][language] ){
        return translationDb[toTranslate][language] ;
    }
    return '';
};

const useTranslate = ( translationDb , DefaultLanguage ) => {
    return ( toTranslate,  language ) => {
        if( !language){
            language = DefaultLanguage;
        }
        return translate (  toTranslate,  language , translationDb );
    }
}

const translate2 = (  toTranslate, translationDb ) => {
    
    let levels = toTranslate.split(".");;
    let currentTransDb = translationDb;
    if( !(levels && currentTransDb && levels.length > 0 ) ){
        return null;
    }

    for( let i = 0 ; i < levels.length ; i++ ){
        if( !(levels[i]?.trim && levels[i].trim() != '') ){
            return null;
        }
        if( !currentTransDb[levels[i]]){
            return null;
        }
        currentTransDb = currentTransDb[levels[i]];
    }

    if( currentTransDb ){
        return currentTransDb;
    }
    return null;
};

const useTranslate2 = ( translationDb  ) => {
    return ( toTranslate , fallback ) => {
        const translated = translate2 (  toTranslate , translationDb );
        return translated ?? fallback;
    }
}



export { useTranslate, translate , useTranslate2, translate2 } ;